import React, { useEffect, useRef, useState } from "react";
import { Link, useParams } from "react-router-dom";
import ProductsMapList from "./ProductsMapList";
import { useDispatch, useSelector } from "react-redux";
import { getList, setTotalProducts } from "../reducer/productListSlice";
import { apiBaseUrl } from "../config";
import axios from "axios";
import { getCategory, getSubcategory } from "../reducer/categorySlice";
import GoogleReviews from "./GoogleReviews/GoogleReviews";
import TermsCondition from "./TermsCondition/TermsCondition";
import ViewMore from "./ViewMore/ViewMore";
import AllProducts from "./AllProducts/AllProducts";
import ViewMoreContent from "./ViewMoreContent/ViewMoreContent";
import Loader from "./loader/Loader";
import { getDomainInfo } from "../utils/utils";
import { useUser } from "../context/userContext";

function StoreTabContent({ cartLength }) {


    const { userId } = useParams();
  
  const userid = useSelector((state) => state.fetchUser?.user?.id);
  const customSort = useSelector((state) => state.fetchUser?.user?.customSort);
  const cart = useSelector((state) => state.fetchCart?.cartInfo?.cartItem);
  const checkboxesRef = useRef([]);
  const [isLoading, setIsLoading] = useState(false);

  const dispatch = useDispatch();
  const [totalProductLength, setTotalProductLength] = useState(0);
  const [showAllCategories, setShowAllCategories] = useState(false);
  const [subcategoryIds, setSubCategoryIds] = useState([]);
  const [categoryIds, setCategoryIds] = useState([]);
  const [productCategory, setProductCategory] = useState([]);

const { uid } = getDomainInfo(userId);
  const { userData, fetchUserData } = useUser();
  
        useEffect(() => {
          if (uid) {
           fetchUserData(uid);
          } else {
            console.error("UID is undefined, skipping fetchUserData.");
          }
        }, [uid]);
  
  const fetchCategories = async () => {
    try {
      if (!userid) {
        console.error("User ID is undefined, cannot fetch categories.");
        return;
      }
      const response = await fetch(
        `${apiBaseUrl}user/get-seller-product-categories/${userid}`
      );
      const data = await response.json();

      if (Array.isArray(data)) {
        setProductCategory(data);
      } else if (data?.categories) {
        setProductCategory(data.categories);
      }
    } catch (error) {
      console.error("Error fetching categories:", error);
    }
  };

  // const fetchSubCategory = async () => {
  //   try {
  //     const response = await axios.post(
  //       `${apiBaseUrl}user/get-seller-subcategories/${userId}`,
  //       { categoryIds: categoryIds }
  //     );
  //     if (response) {
  //       setSubCategory(response?.data?.subcategories);
  //     }
  //   } catch (error) {}
  // };
  
  function handleSubCategoryIdAdd(e, id) {
    if (e.target.checked === true) {
      setSubCategoryIds([...subcategoryIds, id]);
    } else if (e.target.checked === false) {
      const newSubCatIds = subcategoryIds?.filter((item) => item !== id);
      setSubCategoryIds([...newSubCatIds]);
    }
  }

  useEffect(() => {
    if (categoryIds.length === 0) {
      setSubCategoryIds([]);
    }
  }, [categoryIds]);

  function handleCategorySelect(e, id) {
    if (e.target.checked === true) {
      setCategoryIds([...categoryIds, id]);
    } else if (e.target.checked === false) {
      const newCatIds = categoryIds?.filter((item) => item !== id);
      setCategoryIds([...newCatIds]);
    }
  }
  function handleAllCategorySelect(e) {
    if (e.target.checked === true) {
      setCategoryIds([]);
      resetCheckboxes();
    }
  }

  const resetCheckboxes = () => {
    checkboxesRef.current.forEach((checkbox) => {
      if (checkbox) checkbox.checked = false;
    });
  };

  function getSubcategoriesByCategoryIds() {
    // Filter categories that match any of the titles in the provided array
    const matchedCategories = productCategory?.filter((cat) =>
      categoryIds.includes(cat._id)
    );
    const subcategories = matchedCategories.flatMap((cat) => cat.subcategories);
    dispatch(getSubcategory(subcategories));
  }

  useEffect(() => {
    if (categoryIds.length > 0) {
      getSubcategoriesByCategoryIds();
    } else if (categoryIds.length === 0) {
      const allSub = productCategory?.flatMap((sub) => sub.subcategories);
      dispatch(getSubcategory(allSub));
    }
  }, [categoryIds]);

  const fetchProductList = async () => {
    if (!userid) return;
    try {
      setIsLoading(true);
      const response = await axios.post(
        `${apiBaseUrl}user/filter-seller-products-by-category/${userid}`,
        {
          categoryIds: subcategoryIds,
          customSort: customSort,
          skip: 0,
          limit: 12,
        }
      );
      // const data = await response.json();
      if (response) {
        dispatch(getList(response?.data?.products));
        dispatch(setTotalProducts(response?.data?.totalCount));
        setTotalProductLength(response?.data?.products?.length);
      }
      setIsLoading(false);
    } catch (error) {
      console.error("Error fetching Products:", error);
      setIsLoading(false);
    }
  };

  const fetchProductListByCategory = async () => {
    try {
      setIsLoading(true);
      const response = await axios.post(
        `${apiBaseUrl}user/filter-seller-products-by-category/${userid}`,
        { categoryIds: categoryIds }
      );
      // const data = await response.json();
      if (response) {
        dispatch(getList(response?.data?.products));
        dispatch(setTotalProducts(response?.data?.totalCount));
        setTotalProductLength(response?.data?.products?.length);
      }
      setIsLoading(false);
    } catch (error) {
      console.error("Error fetching Products:", error);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (categoryIds.length > 0) {
      fetchProductListByCategory();
    }
  }, [categoryIds]);

  useEffect(() => {
    if (categoryIds.length === 0 && subcategoryIds.length === 0) {
      fetchProductList();
    }
  }, [categoryIds, subcategoryIds]);

  useEffect(() => {
    if (userid !== undefined) {
      fetchCategories();
      fetchProductList();
    }
  }, [userid]);

  return (
    <>
      {isLoading && <Loader />}
      {productCategory.length > 0 ? (
        <div className="catagory-list" id="storeCategoryList">
          <ul>
            <li>
              <input
                className={"fontclass"}
                name={"allCategory"}
                id={"allCategory"}
                type="checkbox"
                value={"allCategory"}
                checked={categoryIds?.length === 0}
                onChange={(e) => handleAllCategorySelect(e)}
              />
              <label htmlFor={"allCategory"} to="">
                All
              </label>
            </li>
            {productCategory &&
              (showAllCategories
                ? productCategory
                : productCategory.slice(0, 5)
              ).map((item, index) => (
                <li key={index} style={{ position: "relative" }}>
                  <input
                    className={"fontclass"}
                    name={"cat" + index}
                    id={"cat" + index}
                    type="checkbox"
                    value={item._id}
                    ref={(el) => (checkboxesRef.current[index] = el)}
                    onChange={(e) => handleCategorySelect(e, item._id)}
                  />
                  <label htmlFor={"cat" + index} to="">
                    {item.title}
                  </label>
                </li>
              ))}
          </ul>
          {/* {productCatagory && productCatagory.length > 4 && (
                        <button
                            className="border-0 m-auto d-flex justify-content-center"
                            onClick={() => setShowAllCategories(!showAllCategories)}
                        >
                            {showAllCategories ? (
                                <i className="fa-solid fa-angles-up"></i>
                            ) : (
                                <i className="fa-solid fa-angles-down"></i>
                            )}
                        </button>
                    )} */}
        </div>
      ) : (
        <p className="text-center"> No Category Found</p>
      )}

      <AllProducts categoryIds={categoryIds} 
        onResetCategorySelection={() => {
          setCategoryIds([]);
          resetCheckboxes();
      }}/>
      {/* <ViewMoreContent subcategoryIds={subcategoryIds} uid={uid}/> */}

      {/* ----------------- uncomment this ------> */}
      {/* <button type="button" className="btn btn-primary" data-bs-toggle="modal" data-bs-target="#socialshare">
                social share
            </button> */}

      {/* social share */}
      {/* <ShareModal /> */}

      <div className="store-sections">
        <GoogleReviews />
        <TermsCondition userId={userid} />
      </div>
    </>
  );
}

export default StoreTabContent;
